// extracted by mini-css-extract-plugin
export default {"UploadsList":"UploadsList_UploadsList__F+RCf"};